import React from "react"
import autobind from "class-autobind"
import { RaisedButton, TextField } from "material-ui"
import { ITaskDocument } from "../../../models"
import moment from "moment"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AppStateStore from "../../../stores/AppStateStore"

interface IProps {
    task: ITaskDocument
    onCompleteTask(taskId: string): void
}
interface IState {
    phoneNumber: string
    phoneError: string
    validatingPhone: boolean
}

export default class TaskTypeSMSAppLink extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            phoneNumber: "",
            phoneError: null,
            validatingPhone: false,
        }
        autobind(this)
    }

    onSendSMS() {
        this.validateAndSendSMS()
    }

    validateAndSendSMS() {
        let isValidate = true
        this.setState({ validatingPhone: true, phoneError: null }, () =>
            api.validatePhone(this.state.phoneNumber, AuthenticationStore.getCookieAccountId())
                .then(res => {
                    if (res.data) {
                        this.setState({ phoneError: res.data, validatingPhone: false })
                    } else {
                        this.setState({ phoneError: "", validatingPhone: false })

                        !this.props.task.Completed &&
                            this.props.onCompleteTask(this.props.task.Id)

                        api.sendAppDownloadSMS(this.props.task.Id, this.state.phoneNumber).then(() =>
                            AppStateStore.setProgressSnackbarContent(strings.App_Link_Sent)
                        )
                    }
                })
                .catch(err =>
                    AppStateStore.setProgressSnackbarContent(err.response.data.message)
                )
        )
        return isValidate
    }

    render() {
        return (
            <div>
                {this.props.task.Completed &&
                    <div style={{ marginBottom: 20 }}>
                        Completed: {moment(this.props.task.CompletedDate).format("hh:mma MM/DD/YYYY")}
                    </div>
                }
                <TextField
                    floatingLabelText={strings.MobileAppPhoneLabel}
                    value={this.state.phoneNumber}
                    errorText={this.state.phoneError}
                    errorStyle={{ position: "absolute", top: 68 }}
                    style={{ width: 300 }}
                    onChange={event => this.setState({ phoneNumber: event.target.value, phoneError: null })}
                />
                <RaisedButton
                    label={this.props.task.Completed ? strings.ReSendMobileAppSMS : strings.SendMobileAppSMS}
                    style={{ marginLeft: 60, marginTop: -8 }}
                    backgroundColor="#1181F2"
                    labelColor="white"
                    disabled={this.state.validatingPhone}
                    onClick={this.onSendSMS}
                />
            </div>
        )
    }
}